<template>
  <form @submit.prevent="handleSubmit(item)">
    <b-row>
      <b-col lg="4" sm="6">
        <div class="form-group">
          <label
                  for="excmconsent_title"
                  class="form-control-label">{{$t('views.excmconsent.form.title')}}:</label>
          <input
                  id="excmconsent_title"
                  v-model="item.title"
                  :class="['form-control', isInvalid('title') ? 'is-invalid' : '']"
                  type="text"
                  placeholder=""
                  @input="handleUpdateField('title', $event.target.value)">
          <div
                  v-if="isInvalid('title')"
                  class="invalid-feedback">{{ violations.title }}</div>
        </div>
      </b-col>
      <b-col lg="4" sm="6">
        <div class="form-group">
          <label
                  for="excmconsent_description"
                  class="form-control-label">{{$t('views.excmconsent.form.description')}}:</label>
          <input
                  id="excmconsent_description"
                  v-model="item.description"
                  :class="['form-control', isInvalid('description') ? 'is-invalid' : '']"
                  type="text"
                  placeholder=""
                  @input="handleUpdateField('description', $event.target.value)">
          <div
                  v-if="isInvalid('description')"
                  class="invalid-feedback">{{ violations.description }}</div>
        </div>
      </b-col>
      <b-col lg="4" sm="6">
        <div class="form-group">
          <label
                  for="excmconsent_agreementType"
                  class="form-control-label">{{$t('views.excmconsent.form.agreementType')}}:</label>
          <fg-input :error="violations.agreementType">
            <el-select
                    id="exsbitem_itemType"
                    :class="['select-default', isInvalid('agreementType') ? 'select-danger' : '']"
                    :placeholder="$t('views.excmconsent.form.agreementType')"
                    filterable
                    v-model="item.agreementType">
              <el-option v-for="option in agreementTypeOptions"
                         class="select-default"
                         :value="option['@id']"
                         :label="option.title"
                         :key="option['@id']">
              </el-option>
            </el-select>
          </fg-input>
          <div
                  v-if="isInvalid('itemType')"
                  class="invalid-feedback">{{ violations.agreementType }}</div>
        </div>
      </b-col>
      <!--<b-col lg="12" sm="12">-->
        <!--<div class="form-group">-->
          <!--<label-->
                  <!--for="excmconsent_orderConsent"-->
                  <!--class="form-control-label">{{$t('views.excmconsent.form.orderConsent')}}:</label>-->
          <!--<input-->
                  <!--id="excmconsent_orderConsent"-->
                  <!--v-model="item.orderConsent"-->
                  <!--:class="['form-control', isInvalid('orderConsent') ? 'is-invalid' : '']"-->
                  <!--type="number"-->
                  <!--placeholder=""-->
                  <!--@input="handleUpdateField('orderConsent', $event.target.value)">-->
          <!--<div-->
                  <!--v-if="isInvalid('orderConsent')"-->
                  <!--class="invalid-feedback">{{ violations.orderConsent }}</div>-->
        <!--</div>-->
      <!--</b-col>-->
    </b-row>
    <b-row>
      <b-col cols="3">
        <label>{{$t('views.consents.form.require')}}: </label>
        <div>
          <b-form-radio-group buttons button-variant="outline-primary" id="requireConsent" v-model="item.requireConsent">
            <b-form-radio button-variant="outline-primary" :value="1">{{$t('buttons.yes')}}</b-form-radio>
            <b-form-radio button-variant="outline-primary" :value="0">{{$t('buttons.no')}}</b-form-radio>
          </b-form-radio-group>
        </div>
      </b-col>
      <b-col cols="3">
        <label>{{$t('views.consents.form.showOnAgreement')}}: </label>
        <div>
          <b-form-radio-group buttons button-variant="outline-primary" id="showOnAgreement" v-model="item.showOnAgreement">
            <b-form-radio button-variant="outline-primary" :value="1">{{$t('buttons.yes')}}</b-form-radio>
            <b-form-radio button-variant="outline-primary" :value="0">{{$t('buttons.no')}}</b-form-radio>
          </b-form-radio-group>
        </div>
      </b-col>
      <b-col cols="3">
        <label>{{$t('views.consents.form.showOnAgreementSign')}}: </label>
        <div>
          <b-form-radio-group buttons button-variant="outline-primary" id="showOnAgreementSign" v-model="item.showOnAgreementSign">
            <b-form-radio button-variant="outline-primary" :value="1">{{$t('buttons.yes')}}</b-form-radio>
            <b-form-radio button-variant="outline-primary" :value="0">{{$t('buttons.no')}}</b-form-radio>
          </b-form-radio-group>
        </div>
      </b-col>
    </b-row>
    <b-row class="mb-2">
      <b-col cols="3">
        <label>{{$t('views.consents.form.showOnAgreementAccept')}}: </label>
        <div>
          <b-form-radio-group buttons button-variant="outline-primary" id="showOnAgreementAccept" v-model="item.showOnAgreementAccept">
            <b-form-radio button-variant="outline-primary" :value="1">{{$t('buttons.yes')}}</b-form-radio>
            <b-form-radio button-variant="outline-primary" :value="0">{{$t('buttons.no')}}</b-form-radio>
          </b-form-radio-group>
        </div>
      </b-col>
      <b-col cols="3">
        <label>{{$t('views.consents.form.showOnline')}}: </label>
        <div>
          <b-form-radio-group buttons button-variant="outline-primary" id="showOnline" v-model="item.showOnline">
            <b-form-radio button-variant="outline-primary" :value="1">{{$t('buttons.yes')}}</b-form-radio>
            <b-form-radio button-variant="outline-primary" :value="0">{{$t('buttons.no')}}</b-form-radio>
          </b-form-radio-group>
        </div>
      </b-col>
      <b-col cols="3">
        <label>{{$t('views.consents.form.consentType')}}: </label>
        <div>
          <b-form-radio-group buttons button-variant="outline-primary" id="consentType" v-model="item.consentType">
            <b-form-radio button-variant="outline-primary" :value="1">{{$t('views.consents.form.forSla')}}</b-form-radio>
            <b-form-radio button-variant="outline-primary" :value="0">{{$t('views.consents.form.forAgreement')}}</b-form-radio>
          </b-form-radio-group>
        </div>
      </b-col>
    </b-row>
    <button
      type="submit"
      class="btn btn-success">{{ $t('buttons.submit') }}</button>
  </form>
</template>

<script>
export default {
  props: {
    handleSubmit: {
      type: Function,
      required: true
    },

    handleUpdateField: {
      type: Function,
      required: true
    },

    values: {
      type: Object,
      required: true
    },

    errors: {
      type: Object,
      default: () => {}
    },

    initialValues: {
      type: Object,
      default: () => {}
    }
  },

  computed: {
    // eslint-disable-next-line
    item () {
      return this.initialValues || this.values
    },

    violations () {
      return this.errors || {}
    }
  },

  data () {
    return {
      agreementTypeOptions: []
    }
  },

  created () {
    this.getEXCMAgreementTypes()
    this.channelEXCMAgreementTypes = this.$store.state.Pusher.subscribe('e_x_c_m_agreement_types')
    this.channelEXCMAgreementTypes.bind('e_x_c_m_agreement_types', data => {
      this.getEXCMAgreementTypes()
    })
  },

  destroyed () {
    this.$store.state.Pusher.unsubscribe('e_x_c_m_agreement_types')
  },

  methods: {
    getEXCMAgreementTypes () {
      let params = {
        'state': 1,
        'pagination': false
      }
      this.$http.get('api/e_x_c_m_agreement_types', {
        params
      })
        .then(response => {
          this.agreementTypeOptions = response.data['hydra:member']
        })
        .catch(error => {
          if (error.response.status === 400) {
            let text = ''
            for (let i in error.response.data) {
              text += error.response.data[i] + '\n'
            }
            this.$Swal({
              type: 'warning',
              title: text,
              timer: 2500
            })
          }
          console.log(error)
        })
    },
    isInvalid (key) {
      return Object.keys(this.violations).length > 0 && this.violations[key]
    }
  }
}
</script>
